import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as actConfirmAction from 'actions/confirm-action';
import styles from './ConfirmActionModal.css';

class ConfirmActionModal extends React.Component {
  render() {
    const {
      showConfirmActionModal,
      customText,
    } = this.props.data.confirmAction;
    return (
      <Modal
        onHide={this._onHide}
        show={showConfirmActionModal}
        dialogClassName={`${styles.dialog} modal-dialog`}
      >
        <Modal.Header className={customText.headerClass}>
          <Modal.Title className={styles['title-modal']}>
            {customText.titleText}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles['body-text']}>
            <strong>{customText.titleBodyText}</strong>
            <br />
            {customText.bodyText}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              className="btn btn-default"
              onClick={this._onConfirm}
            >
              {customText.okText}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this._onHide}
            >
              {customText.cancelText}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  _onHide = () => {
    this.props.dispatch(actConfirmAction.cancelAction());
  };

  _onConfirm = () => {
    const { nextAction } = this.props.data.confirmAction;
    this.props.dispatch(actConfirmAction.confirmAction(nextAction));
  };
}

function mapStateToProps(state) {
  return {
    data: {
      confirmAction: state.confirmAction,
    },
  };
}
export default connect(mapStateToProps)(ConfirmActionModal);
